import useSWR from 'swr';
import { useAccount } from 'wagmi';
import { Address } from 'viem';
import { api, BlinkoReferrerProfile, BlinkoReferralStats, BlinkoReferralCodeResponse } from '../api';

export const REFERRAL_SWR_KEYS = {
  referrer: (address?: Address) => (address ? ['referrer', address] as const : null),
  stats: (address?: Address) => (address ? ['referral-stats', address] as const : null),
  code: (address?: Address) => (address ? ['referral-code', address] as const : null),
};

export const useReferrer = () => {
  const { address } = useAccount();
  return useSWR<BlinkoReferrerProfile | null>(
    REFERRAL_SWR_KEYS.referrer(address),
    () => api.getReferrer(address!),
    {
      revalidateOnFocus: false,
    },
  );
};

export const useReferralStats = () => {
  const { address } = useAccount();
  return useSWR<BlinkoReferralStats>(
    REFERRAL_SWR_KEYS.stats(address),
    () => api.getReferralStats(address!),
    {
      revalidateOnFocus: false,
    },
  );
};

export const useReferralCode = () => {
  const { address } = useAccount();
  return useSWR<BlinkoReferralCodeResponse>(
    REFERRAL_SWR_KEYS.code(address),
    () => api.getReferralCode(address!),
    {
      revalidateOnFocus: false,
    },
  );
};
